import Vue from 'vue'

import VueSweetalert2 from 'vue-sweetalert2';
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'

import debounce from 'lodash/debounce';


import VModal from 'vue-js-modal';




import VueCookies from 'vue-cookies'
import 'sweetalert2/dist/sweetalert2.min.css';

import 'datatables.net'

import 'datatables.net-responsive'

import 'datatables.net-fixedheader'

import './assets/datatables/dataTables.dataTables.css'
import './assets/datatables/responsive.dataTables.css'
import './assets/datatables/fixedHeader.dataTables.css'



import router from './router'
import vuetify from './plugins/vuetify'


import VueCarousel from 'vue-carousel';



import api from './utils/api';

export const bus = new Vue();


Vue.$api = api

window.context = "careers";

window.companyidcareers = 7;


window.siteForTest = "";
//window.siteForTest = "https://careers.ariall.eu/";
//window.siteForTest = "https://careers.lc-service.it/";
//window.siteForTest = "https://jobmule.eu/";


window.urlSiteCareers = "";

Object.defineProperty(Vue.prototype, '$api', {
  get() {
    return api
  }
})



var loggedIn = window.$cookies.get("token");


Vue.use(VueCarousel);


Vue.use(VueCookies);
Vue.use(debounce);

Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);
Vue.use(VueRouter)

Vue.use(VModal, {
  dialog: true
});

Vue.config.ignoredElements = [/ion:*/]


if (loggedIn) {
  Vue.prototype.userLogged = true;

}


window.App = new Vue({
  router,
  vuetify,

  render: h => h(App)
}).$mount('#app')


if (loggedIn == null) {



  if (!document.location.hash.toString().includes("goToAds") && (!document.location.hash.toString().includes("adsDetail")) && (!document.location.hash.toString().includes("removeAccount"))) {



    router.push({ path: '/searchAds' }).catch(() => { });

  }




}